import { createContext } from 'react';
import { SnackbarMessage } from '../../components/snackbar/Snackbar';

const snackContext = createContext<{
  snackPack: SnackbarMessage[];
  setSnackPack: React.Dispatch<React.SetStateAction<SnackbarMessage[]>>;
}>({ snackPack: [], setSnackPack: () => undefined });

export default snackContext;
